export default "__VITE_ASSET__CeVNQhYi__"